import { SoftAgent, cx } from '@algoboo/ui'
import { userFace, type UserLike } from '../lib/identity'

/** A person's face: their uploaded image, or the mascot derived from their handle (lib/identity). */
export function UserAvatar({ user, size = 24, framing, className }: { user: UserLike; size?: number; framing?: 'full'; className?: string }) {
  const f = userFace(user)
  if (f.kind === 'image')
    return <img src={f.url} alt="" width={size} height={size} loading="lazy" className={cx('shrink-0 rounded-[32%] object-cover', className)} style={{ width: size, height: size }} />
  return <SoftAgent avatar={f.avatar} size={size} title="" className={cx('shrink-0', className)} {...(framing ? { framing } : {})} />
}
